module.exports = __webpack_public_path__ + "partylineManage/fonts/iconfont.58b2f5d3.ttf";